import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import b from 'b_';
import { ResearchStoreProp, EnvStoreProps } from '../../stores/props';
import TopBarDropdown from '../TopBarDropdown/TopBarDropdown';
import './LocationMenu.css';
import MobileModal from '../MobileModal/MobileModal';
import FuseButton from '../FuseControls/FuseButton';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import OldLocationMenu from './OldLocationMenu';

const block = b.lock('NewLocationMenu');

class NewLocationMenu extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        research: ResearchStoreProp,
        env: EnvStoreProps,
        afterChange: PropTypes.func,
    };

    static defaultProps = {
        afterChange: () => {},
    };

    cancelModal = () => {
        this.props.research.locationMenu.close();
    };

    renderFooterActions() {
        const { t } = this.props;

        return <Fragment>
            <FuseButton
                type={FuseButton.type.PRIMARY}
                color={FuseButton.color.BLUE}
                onClick={this.cancelModal}
            >
                {t('userAgentMenu.cancel')}
            </FuseButton>
        </Fragment>;
    }

    renderModal(content) {
        const { research, env } = this.props;

        return (env.screen.isMobile || env.screen.isTablet || env.isTouchDevice)
            ? <MobileModal
                isOpen={research.locationMenu.isOpen}
                onClose={research.locationMenu.close}
                shouldCloseOnOverlayClick={false}
                footerActions={this.renderFooterActions()}
            >{content}</MobileModal>
            : <TopBarDropdown
                className="LocationMenu"
                type="research"
                onClose={research.locationMenu.close}
            >{content}</TopBarDropdown>;
    }

    render() {
        const { t, research, afterChange } = this.props;
        return this.renderModal(<Fragment>
            {/* Section header */}
            <div className={block('SectionHeader')}>
                {t('locationMenu.selectLocation', 'Select Location')}
            </div>
            {research.locations.map((location) => {
                const isSelected = research.location === location.id;
                const isDefault = location.name.startsWith('Default:');
                const cleanName = isDefault ? location.name.replace('Default:', '').trim() : location.name;
                return <div
                    key={location.id}
                    className={block('Item')}
                >
                    <div
                        className={block('Menu', { selected: isSelected })}
                        onClick={(e) => {
                            e.stopPropagation();
                            research.setLocation(location.id);
                            research.locationMenu.close();
                            afterChange();
                        }}
                    >
                        <div className={block('OptionText')}>{cleanName}</div>
                        {isDefault && (
                            <div className={block('Badge')}>
                                <div className={block('BadgeText')}>Default</div>
                            </div>
                        )}
                    </div>
                </div>;
            })}
        </Fragment>);
    }
}

const WrappedNewLocationMenu = translate()(inject('research', 'browser', 'env')(observer(NewLocationMenu)));

const LocationMenu = (props) => {
    return isFuse5Enabled() ? <WrappedNewLocationMenu {...props} /> : <OldLocationMenu {...props} />;
};

export default LocationMenu;
